<template>
<m-pageframe
    title="View Payment"
>
<v-container>
    <m-payment-card
        v-if="payment != null"
        :payment="payment"
        v-on:changed="loadPayment"
     />

</v-container>
</m-pageframe>
</template>

<script>
export default {
    data() {
        return {
            payment: null,
        }
    },

    mounted () {
        this.loadPayment();
    },

    created () {
        this.$event_bus.$on('upsert-payment', this.loadPayment);
        
    },

    beforeDestroy () {
        this.$event_bus.$off('upsert-payment',this.loadPayment);
    },
    
    methods: {
        loadPayment() {
            this.payment = null;

            let search = {
                'full_text' : this.$route.params.payment_id,
            };

            this.$rc.showSpinner();

            this.$rc.searchPayments(
                search,

                (data) => {
                    this.$rc.hideSpinner();
                    if ( data.results.length != 0 )
                        this.payment = data.results[0];
                },

                () => {
                    this.$rc.hideSpinner();
                }
            );
        }
    },
}
</script>

<style lang="scss" scoped>
</style>